import types from './types'

export const getCreditPoint = (payload) => ({ type: types.GET_CREDIT_POINTS, payload })
export const getCreditPointResponse = (payload) => ({ type: types.GET_CREDIT_POINTS_RESPONSE, payload })
export const getCreditPointClear = () => ({ type: types.GET_CREDIT_POINTS_CLEAR })